<template>
  <q-dialog v-model="shown">
    <q-card
      v-if="user"
      :style="{ 'width': '250px', 'max-width': '95%' }"
    >
      <q-card-section class="text-h5">
        {{ user.accountClaimed ? 'Password Reset' : 'Claim Account' }}
      </q-card-section>
      <q-card-section>
        {{ user.accountClaimed ? 'Send password reset email' : 'Send claim account email' }}
      </q-card-section>

      <q-card-actions class="row justify-between q-ma-sm">
        <q-btn
          :disabled="!currentUser.admin"
          label="Send"
          color="negative"
          :loading="sending"
          @click="resetPassword"
        >
          <q-tooltip v-if="!currentUser.admin">
            Must be admin to reset password
          </q-tooltip>
        </q-btn>
        <q-space />
        <q-btn
          v-close-popup
          :label="$t('actions.cancel')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'ResetPasswordDialog',
  props: {
    user: {
      type: Object,
      required: false,
      default: null
    }
  },
  context: ['currentUser'],
  data () {
    return {
      shown: false,
      sending: false
    }
  },

  methods: {
    async resetPassword () {
      this.sending = true
      await this.user.requestPasswordReset()
      this.sending = false
      this.shown = false
    },
    show () {
      this.shown = true
    }
  }
}

</script>
